<template>
  <!-- <div class="container-fluid"> -->
  <div>
    <div class="row">
      <div class="col-lg-12">
        <card type="tasks" style="height: auto; padding-bottom: 30px">
          <div class="col-sm-6">
            <div
              class="badge badge-primary"
              style="font-size: 16px; margin-top: 6px; padding: 6px"
            >
              oss链接管理
            </div>
          </div>
          <div class="col-sm" style="margin-top: 66px">
            <label for="exampleInputPassword1" style="font-size: 14px"
              >需要删除的oss链接：</label
            >
            <base-input
              type="text"
              placeholder="请输入素材链接"
              style="margin-top: 4px"
              v-model="link"
            >
            </base-input>
            <div style="display: flex; justify-content: flex-end">
              <base-button
                class="mt-3"
                native-type="submit"
                type="primary"
                @click="handleDelete"
                >删除</base-button
              >
            </div>
          </div>
        </card>
      </div>

      <!-- <div class="col-lg-6">
        <card
          type="tasks"
          class="col-sm"
          style="height: auto; padding-bottom: 30px;overflow-x: auto;"
        >
          <div
            class="badge badge-primary"
            style="font-size: 16px; margin-top: 6px; padding: 6px"
          >
            公告管理
          </div>
          <div style="margin-top: 26px">
            <base-table :data="tableData" :columns="columns">
              <template slot="columns">
                <th>id</th>
                <th style="width: 80px;">颜色</th>
                <th>内容</th>
                <th >添加时间</th>
                <th style="width: 100px;" class="text-center">操作</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ colorFun(row.color) }}</td>
                <td>{{ row.content }}</td>
                <td>{{ changeDateFormat(row.add_time) }}</td>
                <td class="td-actions ext-center" >
                  <base-button
                    type="success"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="editNotice(row.id, row.color, row.content)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-settings"
                    ></i>
                  </base-button>
                  <base-button
                    type="danger"
                    style="margin-left: 6px"
                    size="sm"
                    icon
                    @click="deleteNotice(row.id)"
                  >
                    <i
                      style="color: #ffffff"
                      class="tim-icons icon-simple-remove"
                    ></i>
                  </base-button>
                </td>
              </template>
            </base-table>
            <div style="display: flex; justify-content: flex-end">
              <base-button
                style="margin-top: 56px"
                native-type="submit"
                type="primary"
                @click="handleAddNotice"
                >添加公告</base-button
              >
            </div>
          </div>
        </card>
      </div> -->
    </div>
    <!-- <div>
      <modal
        :show.sync="modals"
        v-model="noticeType"
        headerClasses="justify-content-center"
      >
        <h4 slot="header" class="title title-up">{{ noticeTitle }}</h4>
        <div>
          <base-input label="请输入公告内容：">
            <textarea
              ref="myTextarea"
              v-model="myTextareaValue"
              style="padding: 0"
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea>
          </base-input>
          <div style="margin-top: 20px">
            公告颜色：
            <el-select
              class="select-danger"
              placeholder="Single Select"
              v-model="selects.simple"
            >
              <el-option
                v-for="option in selects.languages"
                class="select-danger"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
          "
        >
          <base-button
            type="secondary"
            @click="modals = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="doAddNotice"
            >确认</base-button
          >
        </div>
      </modal>
    </div> -->
  </div>
</template>
<script>
import BaseTable from "@/components/BaseTable";
import Modal from "@/components/Modal";
import Swal from "sweetalert2";
import { Select, Option } from "element-ui";
import { http } from "../../util/http.js";
import { changeDateFormat, colorFun } from "../../util/utils.js";
export default {
  data() {
    return {
      colorFun,
      changeDateFormat,
      link: "",
      myTextareaValue: "",
      modals: false,
      noticeId: 0,
      columns: ["id", "color", "content", "add_time", "actions"],
      BaseTable,
      tableData: [],
      noticeType: "",
      noticeTitle: "",
      selects: {
        simple: "请选择公告颜色",
        languages: [
          { value: "#67C23A", label: "绿色" },
          { value: "#F56C6C", label: "红色" },
          { value: "#4169E1", label: "蓝色" },
          { value: "#EE00EE", label: "紫色" },
          { value: "#97FFFF", label: "青色" },
        ],
      },
    };
  },
  components: {
    // BaseTable,
    // Modal,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  mounted() {
    // http
    //   .get("/v1/admin/getAllNotice", {
    //     headers: { adminToken: localStorage.getItem("adminToken") },
    //   })
    //   .then((res) => {
    //     if (res.data.code != 200) {
    //       this.$notify({
    //         type: "danger",
    //         message: res.data.message,
    //         timeout: 2000,
    //         icon: "tim-icons icon-bell-55",
    //       });
    //       return;
    //     }
    //     this.tableData = res.data.data;
    //   })
    //   .catch((error) => {
    //     console.error("发生错误:", error);
    //     // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    //   });
  },
  methods: {
    // doAddNotice() {
    //   // 执行添加公告
    //   if (this.myTextareaValue == "") {
    //     this.$notify({
    //       type: "danger",
    //       message: "请输入公告内容",
    //       timeout: 2000,
    //       icon: "tim-icons icon-bell-55",
    //     });
    //     return;
    //   }
    //   if (this.selects.simple == "请选择公告颜色") {
    //     this.$notify({
    //       type: "danger",
    //       message: "请选择公告颜色",
    //       timeout: 2000,
    //       icon: "tim-icons icon-bell-55",
    //     });
    //     return;
    //   }
    //   if (this.noticeType == "addNotice") {
    //     http
    //       .post(
    //         "/v1/admin/addNotice",
    //         {
    //           content: this.myTextareaValue,
    //           color: this.selects.simple,
    //         },
    //         { headers: { adminToken: localStorage.getItem("adminToken") } }
    //       )
    //       .then((res) => {
    //         if (res.data.code != 200) {
    //           this.$notify({
    //             type: "danger",
    //             message: res.data.message,
    //             timeout: 2000,
    //             icon: "tim-icons icon-bell-55",
    //           });
    //           return;
    //         }
    //         this.modals = false;
    //         this.tableData = res.data.data;
    //         Swal.fire({
    //           icon: "success",
    //           html: "公告添加成功",
    //           customClass: {
    //             confirmButton: "btn btn-success btn-fill",
    //           },
    //           buttonsStyling: false,
    //         });
    //       })
    //       .catch((error) => {
    //         console.error("发生错误:", error);
    //       });
    //   } else {
    //     http
    //       .post(
    //         "/v1/admin/editNotice",
    //         {
    //           id: this.noticeId,
    //           color: this.selects.simple,
    //           content: this.myTextareaValue,
    //         },
    //         { headers: { adminToken: localStorage.getItem("adminToken") } }
    //       )
    //       .then((res) => {
    //         if (res.data.code != 200) {
    //           Swal.fire({
    //             icon: "error",
    //             title: "公告编辑失败",
    //             text: res.data.message,
    //             customClass: {
    //               confirmButton: "btn btn-success btn-fill",
    //             },
    //             buttonsStyling: false,
    //           });
    //           return;
    //         }
    //         this.tableData = res.data.data;
    //         this.modals = false;
    //         Swal.fire({
    //           icon: "success",
    //           html: "公告编辑成功",
    //           customClass: {
    //             confirmButton: "btn btn-success btn-fill",
    //           },
    //           buttonsStyling: false,
    //         });
    //       })
    //       .catch((error) => {
    //         console.error("发生错误:", error);
    //         // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    //       });
    //   }
    // },
    // handleAddNotice() {
    //   // 添加公告按钮
    //   this.modals = true;
    //   this.myTextareaValue = "";
    //   this.noticeType = "addNotice";
    //   this.selects.simple = "请选择公告颜色";
    //   this.noticeTitle = "添加公告";
    //   this.$nextTick(() => {
    //     this.$refs.myTextarea.focus();
    //   });
    // },
    // editNotice(id, color, content) {
    //   // 编辑公告
    //   this.myTextareaValue = content;
    //   this.selects.simple = color;
    //   this.noticeId = id;
    //   this.modals = true;
    //   this.noticeType = "editNotice";
    //   this.noticeTitle = "编辑公告";
    //   this.$nextTick(() => {
    //     this.$refs.myTextarea.focus();
    //   });
    // },
    // deleteNotice(id) {
    //   // 删除公告
    //   Swal.fire({
    //     title: "删除公告",
    //     text: "确定需要删除该公告吗?",
    //     icon: "warning",
    //     showCancelButton: true,
    //     customClass: {
    //       confirmButton: "btn btn-success btn-fill",
    //       cancelButton: "btn btn-danger btn-fill",
    //     },
    //     buttonsStyling: false,
    //     confirmButtonText: "确认",
    //     cancelButtonText: "取消",
    //   }).then((res) => {
    //     if (res.isConfirmed) {
    //       http
    //         .post(
    //           "/v1/admin/deleteNotice",
    //           {
    //             id: id,
    //           },
    //           { headers: { adminToken: localStorage.getItem("adminToken") } }
    //         )
    //         .then((res) => {
    //           if (res.data.code != 200) {
    //             Swal.fire({
    //               icon: "error",
    //               title: "公告删除失败",
    //               text: res.data.message,
    //               customClass: {
    //                 confirmButton: "btn btn-success btn-fill",
    //               },
    //               buttonsStyling: false,
    //             });
    //             return;
    //           }
    //           this.tableData = res.data.data;
    //           Swal.fire({
    //             icon: "success",
    //             html: "公告删除成功",
    //             customClass: {
    //               confirmButton: "btn btn-success btn-fill",
    //             },
    //             buttonsStyling: false,
    //           });
    //         })
    //         .catch((error) => {
    //           console.error("发生错误:", error);
    //           // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    //         });
    //     }
    //   });
    // },
    handleDelete() {
      // 删除oss链接
      if (this.link === "") {
        this.$notify({
          type: "danger",
          message: "链接不能为空!",
          timeout: 2000,
          icon: "tim-icons icon-bell-55",
        });
        return;
      }
      Swal.fire({
        title: "删除链接",
        text: "确定需要删除oss链接吗?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-success btn-fill",
          cancelButton: "btn btn-danger btn-fill",
        },
        buttonsStyling: false,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then((res) => {
        if (res.isConfirmed) {
          http
            .post(
              "/v1/admin/deleteOss",
              {
                link: this.link,
              },
              { headers: { adminToken: localStorage.getItem("adminToken") } }
            )
            .then((res) => {
              if (res.data.code != 200) {
                Swal.fire({
                  icon: "error",
                  title: "删除失败",
                  text: res.data.message,
                  customClass: {
                    confirmButton: "btn btn-success btn-fill",
                  },
                  buttonsStyling: false,
                });
                return;
              }
              Swal.fire({
                icon: "success",
                html: "删除成功",
                customClass: {
                  confirmButton: "btn btn-success btn-fill",
                },
                buttonsStyling: false,
              });
            })
            .catch((error) => {
              console.error("发生错误:", error);
              // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
            });
        }
      });
    },
  },
};
</script>
<style >
.card-calendar {
  min-height: 400px;
  
}

</style>
